import React from 'react'
import { Modal, ModalHeader, ModalBody } from 'reactstrap'

import { EloButton } from '@elo-kit/components/elo-button'

import './styles.scss'

export const CommunityModal = (props) => {
  const {
    cancel,
    children,
    cancelButtonChild,
    submitButtonChild,
    isOpen,
    submit,
    title,
    toggle,
    close,
    onCancel,
    onClose,
    className,
    submitDisabled,
  } = props

  return (
    <Modal isOpen={isOpen} modalClassName={`community-modal ${className}`}>
      <ModalHeader>
        {close && <i className='fas fa-times' onClick={onClose || toggle} />}
        <div className='community-modal__title'>{title}</div>
      </ModalHeader>
      <ModalBody>
        {children}

        {(cancel || submit) && (
          <div className='community-modal__bottom-buttons'>
            {cancel && (
              <EloButton onClick={onCancel || toggle} outlined grey className='button button--no-border'>
                {cancelButtonChild}
              </EloButton>
            )}

            {submit && (
              <EloButton
                onClick={() => {
                  submit()
                  toggle()
                }}
                disabled={submitDisabled}
              >
                {submitButtonChild}
              </EloButton>
            )}
          </div>
        )}
      </ModalBody>
    </Modal>
  )
}

CommunityModal.displayName = 'CommunityModal'

CommunityModal.defaultProps = {
  cancel: true,
  submitButtonChild: I18n.t('react.shared.button.save'),
  submitDisabled: false,
  close: true,
  cancelButtonChild: I18n.t('react.shared.button.cancel'),
}
